import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Link, useHistory, useLocation } from 'react-router';
import { AdsGETApi, AdsGETApiAuth, AdsPUTApi } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';
import PDFUpload from './PDFUpload';

export default function UploadAnswer({ setReload }) {
  const Login = useSelector((state) => state.LoginState);
  const [myData, setMyData] = React.useState([])
  const [URL, setURL] = React.useState("")
  const [UserID, setUserID] = React.useState("")
  const [AnswerDate, setAnswerDate] = React.useState("")
  var date = new Date()
  var today = date.toLocaleDateString()
  useEffect(() => {
    AdsGETApiAuth({
      _fields: "id,meta.answer_sheet,meta.answer_date",
      "filter[meta_query][1][key]": "user_id",
      "filter[meta_query][1][value][0]": Login.userID,
      "filter[meta_query][1][compare]": "=",
    }, slugs.db_slug_user_data)
      .then(res => {
        setUserID(res.data[0].id)
        if (res.data[0].meta.answer_sheet == "") {
          setMyData("")
        }
        else {
          setMyData(res.data[0].meta.answer_sheet)
          setAnswerDate(res.data[0].meta.answer_date)
        }
      })
      .catch(e => {
      })
  }, [])
  return (
    <div style={{ margin: "10px" }}>
      <h2>लिखित पत्रको परीक्षाभएको दिनको उत्तरपुस्तिका Upload गर्नुहोस् ।</h2>

      <div>

        {URL !== "" &&
          <div onClick={() => {
            // myData.push(URL)
            // console.log(answer_sheet,URL,myData)
            setReload(true)
            AdsPUTApi({
              meta: {
                answer_date: `${today}`,
                answer_sheet: `${URL}`
              }
            }, slugs.db_slug_user_data, UserID)
              .then(res => {
                setReload(false)
                window.location.reload();
              })
          }}>
            <span style={{ cursor: "pointer", border: "1px solid black", borderRadius: 5, padding: "5px 15px" }}> Upload Answer</span>
          </div>
        }
        <div className='row my-4'>
          {/* {myData.map((item, index) => ( */}
          {/* {today} */}
          {AnswerDate == today &&
            <div>
              <iframe
                src={`${myData}`}
                style={{ width: "40vw", height: "400px" }}
              />
            </div>
          }
          {/* ))} */}
        </div>
        <PDFUpload
          ImageUrl={URL}
          setImageUrl={setURL}
        />
      </div>
    </div>
  )
}